export function rewardImageFiles(cover, extras) {
  const files = [];
  const add = (value) => {
    if (value == null || value === "") return;
    if (Array.isArray(value)) {
      value.forEach(add);
      return;
    }
    let name = String(value).trim();
    if (!name) return;
    if (name.startsWith("img/")) name = name.slice(4);
    if (!name || files.includes(name)) return;
    files.push(name);
  };
  add(cover);
  add(extras);
  return files;
}

export function rewardLightboxPayload(imgRoot, alt, cover, extras) {
  const root = imgRoot || "";
  const sources = rewardImageFiles(cover, extras).map((file) => (
    /^https?:\/\//i.test(file) || (root && file.startsWith(root)) ? file : root + file
  ));
  return {
    src: sources[0] || "",
    sources,
    alt: alt || "Výhra"
  };
}
